import React, { RefObject } from 'react';

const useClickOutside = (
  refs: Array<RefObject<HTMLElement>> | undefined,
  handler: (event: Event) => void,
) => {
  React.useEffect(() => {
    const listener = (event: Event) => {
      if (!refs) {
        return;
      }
      let containedToAnyRefs = false;

      for (const ref of refs) {
        if (ref && ref.current && ref.current.contains(event.target as Node)) {
          containedToAnyRefs = true;
          break;
        }
      }

      if (!containedToAnyRefs) {
        handler(event);
      }
    };
    window.addEventListener('mousedown', listener);

    return () => {
      window.removeEventListener('mousedown', listener);
    };
  }, [refs, handler]);
};

export default useClickOutside;
